import React from 'react';
import styled from 'styled-components';
import showEllipsis from './showEllipsis';

export default styled(({ ellipsis, ...rest }) => <div {...rest} />)`
  font-size: 1.3rem;
  ${({ ellipsis }) => ellipsis && showEllipsis}
`;
